<script>
import {
    projectState
} from '@app/store/projectStore.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.js';
import {
    modalState
} from '@app/store/modalStore.js';
import { toast } from '@zerodevx/svelte-toast';
import {
    fade
} from 'svelte/transition';
import {
    externalDataState
} from '@app/store/externalDataStore.js';
import {
    onMount
} from 'svelte';
import Swal from 'sweetalert2'

/* CC LIB */
import encode from "@app/external/cc-lib/dist/functions/encode.js";
import defaults from "@app/external/cc-lib/dist/lib/defaults.js";
import formats from "@app/external/cc-lib/dist/lib/formats.js";
import orderByTime from "@app/external/cc-lib/dist/functions/eventGroups/orderByTime.js";
import removeHtmlEntities from "@app/external/cc-lib/dist/functions/eventGroups/removeHtmlEntities.js";

console.info("DEBUG: Initializing project publishing component.");

let progress = 0,
    statusMsg = "Starting publish workflow...",
    copyOfEventGroup,
    eventGroupIndex = 0,
    eventListElement = document.getElementById("EventList"),
    trgProfile = $externalDataState.captionType || "scenerist",
    trgProfileName = formats.getProfileTitleByName(trgProfile),
    trgFrameRate = $projectState.frameRate,
    trgDropFrame = $projectState.dropFrame,
    fileEncoding = "utf-8",
    ignoreAll = false,
    retranslate = false;

async function updateStatus(statusInfo) {
    progress = statusInfo.progress;
    statusMsg = statusInfo.msg;
}

onMount(async () => {
    console.info("DEBUG: Project publishing component mounted.");
    try {
        console.info("DEBUG: ------------Pre-Publish State---------");
        copyOfEventGroup = JSON.parse(JSON.stringify($eventGroupState[eventGroupIndex]));
        copyOfEventGroup = orderByTime(copyOfEventGroup);
        copyOfEventGroup = removeHtmlEntities(copyOfEventGroup);

        console.info("DEBUG: Running Automatic Checks");
        updateStatus({
            progress : 15,
            msg: "Running automatic checks..."
        });

        let preCheckResult = await preExportCheck(copyOfEventGroup.events);

        if (preCheckResult.err) {
            await cancelExport(eventGroupIndex, preCheckResult.eventId);
            return;
        }

        console.info("DEBUG: Running Encode");
        /* Translate for Creator */
        updateStatus({
            progress : 25,
            msg: "Encoding output file..."
        });
        let playerWidth = document.getElementById('PlayerWrapper').clientWidth;
        let playerHeight = document.getElementById('PlayerWrapper').clientHeight;
        
        let options = new defaults.options({
            profile: trgProfile,
            formatOptions: formats.profileMapping[trgProfileName].options.encode,
            frameRate: trgFrameRate,
            dropFrame: trgDropFrame,
            target_profile: formats.profileMapping[trgProfileName].name,
            source_profile: 'closedCaptionProject',
            window: {
                width: playerWidth,
                height: playerHeight,
                xOffset: 0.1 * playerWidth,
                yOffset: 0.1 * playerHeight
            }
        });

        let output = await encode(copyOfEventGroup, options);
        let fileBlob = new Blob([output], {
            type: "text/plain;charset=" + fileEncoding
        });

        console.info("DEBUG: ------------Publish State---------");
        console.info(`DEBUG: Publishing ${trgProfile} file to ${$externalDataState.publishEndpoint}`);
        console.log(output);

        updateStatus({
            progress : 45,
            msg: "Publishing file..."
        });

        if ($externalDataState.promptToRetranslate){
            let retranslateRes = await Swal.fire({
                titleText: "Retranslate",
                text : "Would you like to retranslate other languages based on your changes?",
                showDenyButton: true,
                confirmButtonText: 'Yes',
                denyButtonText: 'No',
                allowOutsideClick : false,
                allowEscapeKey : false,
                buttonsStyling : false,
                customClass: {
                    confirmButton: 'btn btn-primary me-2',
                    denyButton: 'btn btn-outline-secondary',
                }
            });

            if (retranslateRes.isConfirmed){
                retranslate = true;
            } else if (retranslateRes.isDenied){
                retranslate = false;
            }
        }

        

        let publishRes = await fetch($externalDataState.publishEndpoint, {
            method : "PUT",
            headers: {
                "Content-Type": "application/octet-stream",
                "x-caption-retranslate" : retranslate
            },
            body : fileBlob
        });

        console.info(`DEBUG: Publish Response:`);
        console.log(publishRes);
        if (publishRes.status < 200 || publishRes.status > 299){
            console.error(publishRes.statusText);
            throw new Error("Publish failed. Response status: " + publishRes.statusText)
        }

        let publishResInfo = await publishRes.json();
        console.info(`DEBUG: Publish Response JSON:`);
        console.log(publishResInfo);
        console.info("DEBUG: ------------Post-Publish State---------");
        if (publishResInfo.errMessage){
            updateStatus({
                progress : 75,
                msg: "Publish failed with error: "+publishResInfo.errMessage
            });
            console.error(`ERROR: Publish response returned an error.`);
            console.error(publishResInfo.errMessage);
            throw new Error(publishResInfo.errMessage);
        } else {
            updateStatus({
                progress : 75,
                msg: "Publish completed successfully"
            });
            
            console.info(`DEBUG: Navigating to ${$externalDataState.returnTo}.`);
            window.location.replace($externalDataState.returnTo);
        }
    } catch (err) {
        console.info(err, err.msg);
        await Swal.fire({
            titleText: "Save Error",
            text: `There was an error saving your work. Please try again or contact support.`,
            confirmButtonText: 'Ok',
            allowOutsideClick: true,
            buttonsStyling: false,
            customClass: {
                confirmButton: 'btn btn-primary',
                denyButton: 'btn btn-secondary mx-2',
                cancelButton: 'btn btn-outline-secondary',
            }
        });

        modalState.hideModal();
    }
});

/* PreChecks */
async function cancelExport(eventGroupId, eventId) {
    toast.push("Export Aborted", {classes: ['toast-danger']});

    $projectState.selected = eventGroupId;
    $eventGroupState[$projectState.selected].selected = [eventId];
    setTimeout(() => {
        eventListElement.scrollTo(0, eventId * ($eventGroupState[$projectState.selected].type === "subtitle" || $eventGroupState[$projectState.selected].type === "translation" ? 138 : 230));
    }, 250);

    modalState.hideModal();
}

function alertUser(msg) {
    let response = Swal.fire({
        titleText: "Export Pre-Checks",
        text: msg,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Abort',
        denyButtonText: 'Ignore',
        cancelButtonText: 'Ignore All',
        allowOutsideClick: false,
        allowEscapeKey: false,
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn btn-danger',
            denyButton: 'btn btn-secondary mx-2',
            cancelButton: 'btn btn-outline-secondary',
        }
    }).then((result) => {
        if (result.isConfirmed) {
            return true;
        } else if (result.isDenied) {
            return false;
        } else if (result.isDismissed) {
            ignoreAll = true;
            return false;
        }
    });

    return response;
}

async function preExportCheck(events) {
    for (let i = 0; i < events.length; i++) {
        if (!ignoreAll) {
            if (events[i].text) {
                if (isNaN(events[i].start)) {
                    if (await alertUser(`Event ${i+1} is missing a start time.\n Would you like to ABORT your export?`)) {
                        return {
                            err: true,
                            eventId: i
                        }
                    };
                } else if (isNaN(events[i].end)) {
                    if (await alertUser(`Event ${i+1} is missing an end time.\n Would you like to ABORT your export?`)) {
                        return {
                            err: true,
                            eventId: i
                        }
                    };
                } else if (events[i].start === events[i].end) {
                    if (await alertUser(`Event ${i+1} has the same start and end time.\n Would you like to ABORT your export?`)) {
                        return {
                            err: true,
                            eventId: i
                        }
                    };
                } else if (events[i].start > events[i].end) {
                    if (await alertUser(`Event ${i+1} has a start time greater than its end time.\n Would you like to ABORT your export?`)) {
                        return {
                            err: true,
                            eventId: i
                        }
                    };
                } else if (i > 0 && events[i].start < events[i - 1].end) {
                    /* Adding check in case overlap is less than a frame */
                    if (events[i - 1].end - events[i].start < 1 / $projectState.frameRate) {
                        events[i].start = events[i - 1].end;
                    } else if (await alertUser(`Event ${i+1} overlaps with the previous event.\n Would you like to ABORT your export?`)) {
                        return {
                            err: true,
                            eventId: i
                        }
                    };
                }
            } else {
                if (await alertUser(`Event ${i+1} has no text.\n Would you like to ABORT your export?`)) {
                    return {
                        err: true,
                        eventId: i
                    }
                };
            }
        }

    }

    return {
        err: false
    }
}

</script>

<div transition:fade="{{duration: 100}}" class="modal {$modalState === 'publishProjectCustom' ? 'show d-block' : ''}" role="dialog" tabindex="-1" id="LoadExternalProjectModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Save Project</h4>
                <button type="button" class="btn-close" aria-label="Close" on:click={modalState.hideModal}></button>
            </div>
            <div class="modal-body">
                <p ><i class="bi bi-exclamation-diamond-fill"></i> {statusMsg}</p>
                <div class="progress">
                    <div class="progress-bar bg-success progress-bar-striped progress-bar-animated" role="progressbar" style="width: {progress}%;" aria-valuenow="{progress}" aria-valuemin="0" aria-valuemax="100">{progress}%</div>
                </div>
            </div>
        </div>
    </div>
</div>
